module.exports = __webpack_public_path__ + "media/images/vr/promo-catalogo-section-bg-1-b3473e113ac73900b8d6b594c88753ed.jpg";